import { createSelector } from '@reduxjs/toolkit'

import { RootState } from '../../data/store'

const getMyInfoState = (state: RootState) => state?.myInfo

export const getMyInfoData = createSelector(getMyInfoState, (myInfoState) => myInfoState?.data)
